import moment from 'moment';

import { MemberDetailsType } from '../features/settings/types';
import getMiddleNameInitial from './getMiddleNameInitial';

export type IdentifierType = [
  {
    system: string;
    value: string;
  },
];

const patientToUpdateParams = (
  formData: MemberDetailsType,
  identifier: IdentifierType | undefined,
) => {
  const middleNameInitial = getMiddleNameInitial(formData.middleName || '');
  console.log(identifier);

  return {
    resource: {
      resourceType: 'Patient',
      identifier: identifier || [],
      display: formData.firstName + middleNameInitial + ' ' + formData.lastName,
      active: true,
      address: [
        {
          city: formData.city,
          country: formData.country,
          line: [formData.street ?? '', formData.unit ?? ''],
          postalcode: formData.zip,
          state: formData.state,
          use: 'home',
        },
      ],
      birthDate: moment(formData.birthdate).format('YYYY-MM-DD'),
      gender: formData.sex,
      name: [
        {
          family: formData.lastName,
          given: [formData.firstName, ...(formData.middleName ? [formData.middleName] : [])],
          use: 'usual',
        },
      ],
    },
  };
};

export default patientToUpdateParams;
